// extracted by mini-css-extract-plugin
export var link = "TrustPilotReviews-module--link--34312";
export var trustPilotReviews = "TrustPilotReviews-module--trustPilotReviews--4d5ea";
export var trustPilotWidget = "TrustPilotReviews-module--trustPilotWidget--b0237";